import React from 'react';
import { observer } from 'mobx-react-lite';
import '../../../core/enums/GameSpecificTypes.js';
import '../../../core/enums/MaxPayoutDataTypes.js';
import '../../../core/enums/Chat.js';
import '../../../core/enums/GameModes.js';
import '../../../core/enums/IconTypes.js';
import '../../../core/enums/BetStatus.js';
import '../../../core/enums/PopupTypes.js';
import '../../../core/enums/ApiVersion.js';
import '../../../core/enums/RoundStatus.js';
import '../../../core/enums/FreeBetsStatus.js';
import '../../../core/enums/SocketEvents.js';
import { TranslationKeys } from '../../../core/enums/TranslationKeys.js';
import '../../../core/enums/TimeoutMaxValue.js';
import '../../../core/enums/ApiServiceTypes.js';
import '../../../core/enums/EnvironmentTypes.js';
import '../../../core/enums/DefaultQueryValues.js';
import '../../../core/enums/FreeBetWinningType.js';
import '../../../core/enums/DefaultQueryParams.js';
import '../../../core/enums/BetHistoryFilterTypes.js';
import '../../../core/enums/GameThemeTypes.js';
import '../../../core/enums/RequestStatus.js';
import '../../../core/enums/FetchDefaultPaths.js';
import '../../../core/enums/ResponseCodes.js';
import '../../../../_tslib-7a01aab4.js';
import { a1 as doBetStore, z as freeBetStore } from '../../../../validateBalanceOnBet-af4f4a9b.js';
import '../../../core/store/chatStore.js';
import '../../../core/store/wageringStore.js';
import '../../../core/store/roundInfoStore.js';
import '../../../core/store/userCountStore.js';
import '../../../core/store/gameResultStore.js';
import '../../../core/store/resultHashStore.js';
import '../../../core/store/userWinBetsStore.js';
import '../../../core/store/notificationStore.js';
import '../../../core/store/selectedResultInfoStore.js';
import '../../../core/store/forCrashGame/inputValidationStore.js';
import '../../../core/store/forCrashGame/totalBetStore.js';
import { oddStore } from '../../../core/store/forCrashGame/resultReportStore.js';
import '../../../core/store/forCrashGame/gameStore.js';
import '../../../core/services/liveConnection/types.js';
import 'axios';
import '../../../core/services/sound/types.js';
import '../../../core/services/sound/SoundService.js';
import '../../../core/services/sound/defaultSounds.js';
import '../../../core/services/api/types.js';
import '../../../core/services/ApiServices.js';
import '../../../../momentFormat-e9197995.js';
import '../../../core/polyfill.js';
import '../../../contexts/TranslationContext.js';
import '../../../contexts/StoreContext.js';
import { useTranslation } from '../../../hooks/useTranslation.js';
import '../../../core/enums/additionalInputValueChangingButtons.js';
import 'mobx';
import '../../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../../core/enums/BogLineGameConfig.js';
import '../../../core/helpers/parseQuery.js';
import '../../../core/enums/StatisticsSortingTypes.js';
import '../../../core/services/api/BaseApiService.js';
import '../../../core/helpers/deepCopy.js';
import '../../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../../table-line/t_types/enums/PopupTypes.js';
import '../../../core/helpers/formatDate.js';
import '../../../core/helpers/isMobile.js';
import '../../../core/enums/bogGameNames.js';
import '../../../core/helpers/updateHalfBets.js';
import 'howler';
import '../../../../_commonjsHelpers-17aad09c.js';
import '../../../core/helpers/setTranslationValues.js';

var HalfCashOut = observer(function (_a) {
    var _b, _c;
    var sectionIndex = _a.sectionIndex, disabled = _a.disabled, isBetsClosed = _a.isBetsClosed;
    var sendCashOut = doBetStore.sendCashOut, doBetSectionsData = doBetStore.doBetSectionsData;
    var _d = doBetSectionsData[sectionIndex], isHalfCashOuted = _d.isHalfCashOuted, betId = _d.betId;
    var CashOut = TranslationKeys.CashOut;
    var isMaxWin = oddStore.isMaxWin;
    var extraFreeBetData = freeBetStore.extraFreeBetData;
    var t = useTranslation();
    return (React.createElement("div", { className: "double-cashout ".concat(disabled, " ").concat((isBetsClosed && isHalfCashOuted) ||
            isMaxWin[sectionIndex] ||
            ((_b = extraFreeBetData === null || extraFreeBetData === void 0 ? void 0 : extraFreeBetData[sectionIndex]) === null || _b === void 0 ? void 0 : _b.isShowPopUp) ||
            ((_c = extraFreeBetData === null || extraFreeBetData === void 0 ? void 0 : extraFreeBetData[sectionIndex]) === null || _c === void 0 ? void 0 : _c.isAlreadySeenPopUp)
            ? 'cashed'
            : '', "\n       \n        "), onClick: function () {
            if (isHalfCashOuted)
                return;
            sendCashOut(sectionIndex, betId, true);
        } },
        React.createElement("p", { className: 'bet-text-from-btn-mini' }, t(CashOut)),
        React.createElement("p", { className: 'bet-text-from-btn-mini' }, "50%")));
});

export { HalfCashOut };
